module.exports = __webpack_public_path__ + "img/Courrier-picard80.347ff796.jpg";